export const jobMaps = {
  'market': [32],
  'sales': [33],
  'support': [34]
}
